import wlConfig from '@@/auto/constants/wlConfig';
import { useConfig } from '@@/common/services/useConfig';

import ErrorBoundaryView from './ErrorBoundaryView';

export default function ErrorBoundaryViewForTenant() {
  // Note: we're importing defaults here because withGlobals is occasionally called outside the config context
  const {
    config: {
      errorBoundaryConfig = wlConfig.errorBoundaryConfig,
      errorPageConfig = wlConfig.errorPageConfig,
    } = {},
  } = useConfig() || {};

  return (
    <ErrorBoundaryView
      errorBoundaryConfig={errorBoundaryConfig}
      errorPageConfig={errorPageConfig}
    />
  );
}
